import { useState } from 'react'

import { Hint } from '@factorialco/deprecated-design-system'
import { LOCAL_STORAGE_KEYS } from 'config/Vars'

import { observer } from 'mobx-react'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useEffect } from 'modules/core/hooks/useEffect'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'
import useLocalStorage from 'modules/core/lib/useLocalStorage'

import { isManager } from 'modules/employees/lib/isManager'

import employeeStep1 from './assets/Employee_Step_1.jpg'
import managerStep1 from './assets/Manager_Step_1.jpg'
import managerStep2 from './assets/Manager_Step_2.jpg'
import managerStep3 from './assets/Manager_Step_3.jpg'

const MissingClockInInconsistency = ({ isClockInPage }: { isClockInPage?: boolean }) => {
  const [step, setStep] = useState<number>(1)
  const { company, employee } = useCurrentSession()
  const isUserManager = isManager(employee)
  const [hasSeenHintModal, setHasSeenHintModal] = useLocalStorage<boolean>(
    LOCAL_STORAGE_KEYS.hideMissingClockInInconsistencyBanner,
    false
  )
  const trackingData = {
    feature: 'time_alerts',
    company_id: company.id,
  }

  useEffect(() => {
    if (!hasSeenHintModal) {
      track(trackingEvents.timeTracking.openHintModalTimeTracking, trackingData)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (hasSeenHintModal || (isUserManager && !!isClockInPage) || (!isUserManager && !isClockInPage))
    return null

  const onClose = () => {
    setHasSeenHintModal(true)
    track(trackingEvents.timeTracking.cancelHintModalTimeTracking, {
      ...trackingData,
      step,
    })
  }

  const onChange = (step: string) => {
    setStep(parseInt(step))
  }

  const onFinish = () => {
    if (!hasSeenHintModal) {
      setHasSeenHintModal(true)
    }
  }

  if (isUserManager)
    return (
      <Hint.NewModal onClose={onClose} onFinish={onFinish} onChange={onChange}>
        <div id="1">
          <Hint.NewModal.ImageStep
            src={managerStep1}
            title={i18n.t('time_insights.missing_clock_in_alert_type.manager.step_1.title')}
            description={i18n.t(
              'time_insights.missing_clock_in_alert_type.manager.step_1.description'
            )}
          />
        </div>
        <div id="2">
          <Hint.NewModal.ImageStep
            src={managerStep2}
            title={i18n.t('time_insights.missing_clock_in_alert_type.manager.step_2.title')}
            description={i18n.t(
              'time_insights.missing_clock_in_alert_type.manager.step_2.description'
            )}
          />
        </div>
        <div id="3">
          <Hint.NewModal.ImageStep
            src={managerStep3}
            title={i18n.t('time_insights.missing_clock_in_alert_type.manager.step_3.title')}
            description={i18n.t(
              'time_insights.missing_clock_in_alert_type.manager.step_3.description'
            )}
          />
        </div>
      </Hint.NewModal>
    )

  return (
    <Hint.NewModal onClose={onClose} onFinish={onFinish}>
      <div id="1">
        <Hint.NewModal.ImageStep
          src={employeeStep1}
          title={i18n.t('time_insights.missing_clock_in_alert_type.employee.step_1.title')}
          description={i18n.t(
            'time_insights.missing_clock_in_alert_type.employee.step_1.description'
          )}
        />
      </div>
    </Hint.NewModal>
  )
}

export default observer(MissingClockInInconsistency)
